export default {
	'en': {
		'enterprise': {
			'no-data': 'No Data',
			'no-module-data': 'No Module Data',
			'no-menu-data': 'No Data',
			'irstore': '{name} Investor Relations',
			'irstore-title': 'Investor Relations',
			'loading': 'Loading...',
			'loading-no-more': 'No more data',
			'top-post': 'Top',
			'404-error': 'Error',
			'404-back': 'Back Home',
			'hontron-irstore-title': 'Investor Relations',

			'submit': 'Submit',
			'cancel': 'Cancel',
			// 留言成功提示
			'message-sent-success': 'Successfully, thank you for your attention and suggestions!',
			'error': 'Error',

			'common-a': {
				'updated': 'Updated',
				'until': 'Updated'
			},
			'common-b': {
				'updated': 'Updated'
			},

			// 其他
			'more': 'More',
			'see-more': 'More',
			'realize-more': 'More',
			'view-details': 'More',
			'details': 'More',
			'previes': 'Preview',
			'all': 'All',
			'communication-and-connection': 'Communication and connection',
			'communication-and-connection--RYC': 'Investor Contact',

			'IR-Contact': 'IR Contact',
			'time': 'Time',
			'type': 'Type',
			'rating-type': 'Rating',
			'operate': 'Operate',
			'view': 'View',
			'source': 'Source',
			'unchanged': '0.00',
			'download': 'Download',

			'top': 'Top',
			'whistleblower': 'Whistleblower',
			'message-subscription': 'Email Subscription',

			'sie-home': 'Home',
			'eyebright-home': 'Home',
			'home': 'Home',
			'indicators': 'Indicators',
			'back': 'Back',

			'phone': 'Phone',
			'mailbox': 'Email',
			'address': 'Address',

			// 股票行情
			'chg': 'Chg',
			'%Chg': '%Chg',
			'high': 'High',
			'low': 'Low',
			'P/E': 'P/E(TTM)',
			'clear-P/E': 'P/E',
			'P/B': 'P/B',
			'turnover': 'Turnover',
			'volume': 'Volume',
			'market-cap': 'Market Cap',
			'market-cap-in-hk09606': 'Market Cap (HKD)',
			'float-cap': 'Float Cap',
			'loss': 'Loss',
			'market-quotes': 'Market Quotes',
			'day': 'Day',
			'week': 'Week',
			'month': 'Month',
			'candle': 'Candle',
			'candle-picture': 'Candle',
			'UTC': 'UTC+8',
			'EDT': 'EDT',
			'financial-indicators': 'Financial Indicators',
			'rmb': 'RMB',

			// 股票行情-K线图
			'k-high': 'High',
			'k-low': 'Low',
			'k-turnover': 'Turnover',
			'k-volume': 'Volume',

			'k-opening': 'Open',
			'k-closing': 'Close',
			'k-chg': 'Chg',
			'quotes-data': 'Quotes Data',

			// 分红配送
			'dividend-announced': 'Year',
			'announced': 'Announced',
			'ex-date': 'Ex-Date',
			'record-date': 'Record Date',
			'payment-date': 'Payment Date',
			'dividend-scheme': 'Dividend Scheme (Per 10 shares)',
			'recent-dividend-scheme': 'Recent Dividends (Per 10 shares)',
			'bonus-issue/by-reserve': 'Bonus Issue/by Reserve (Per 10 shares)',
			'dividends': 'Dividends',
			'disclaimer':
				'Power by Comein Finance. No content herein shall be considered an offer, solicitation or recommendation for the purchase or sale of securities or other investment products.',
			'total-dividend': 'Total Dividend',
			'recent-dividends': 'Recent Dividends',
			'frequency': 'Frequency',
			'progress': 'Progress',
			'div-yied': 'Div Yied',
			'dividend-ratio': 'Dividend Payout Ratio',

			// 投关活动
			'default-search': 'Search',
			'IR-events': 'IR Events',
			'investment': {
				// --------路演状态
				'preview': 'Preview',
				'live': 'Live',
				'playback': 'Playback',
				'ended': 'Ended',
				// --------路演权限
				'audition': 'Audition',
				'plubic': 'Plubic',
				'pay': 'Pay',
				'special': 'Special',
				'private': 'Private',
				'apply': 'Apply',
				'member': 'Member',
				'institution': 'Institution',
				'views': 'views',
				'summary': 'Summary',
				'roadshow': 'IR Event',
				'research': 'IR Event',

				'activity-title': 'Activity Title'
			},
			'earnings-disclosure': 'Earnings Disclosure',
			'shareholders-meeting': "Shareholders' Meeting",

			// 新闻资讯
			'news': 'News',
			'news-detail': 'News Detail',
			'report-detail': 'Report Detail',
			'report-title': 'Report Title',
			'publish-org': 'Institution',
			'data-time': 'Data Time',
			'news-updated': 'Updated',
			'news-resource': 'Resource',
			// 互动问答
			'QA': {
				'search': 'Search'
			},
			'question': 'Question',
			'interactive': 'Interactive Q&A',
			'answer': 'A',
			'fold': 'Fold',
			'from-leave-message': 'From Leave Message',
			'answer-to-message': '',
			'disclose-to-message': '',

			// 季度业绩
			//--------- 业绩期
			'annual': 'Annual',
			'interim': 'Interim',
			'first-quarter': 'First Quarter',
			'third-quarter': 'Third Quarter',
			'fourth-quarter': 'Fourth Quarter',

			//--------- - 内容标题
			'quarter-title': {
				'financial-indicators': 'Financial Indicators' // 季度业绩-内容标题-财务数据
			},
			'results-announcement': 'Announcement',
			'results-summary': 'Summary',
			'earnings-calls': 'Calls',
			'earnings-presentation': 'Presentation',
			'business-review-and-outlook': 'BUSINESS REVIEW AND OUTLOOK',
			'page-version': 'Page Version',
			'earnings-library': 'Earnings Library',
			'roadshow-status': {
				'1': 'In Preparation',
				'2': 'Pending Approval',
				'3': 'Disapproved',
				'4': 'Approved',
				'5': 'Upcoming',
				'6': 'In Progress',
				'7': 'Ended',
				'8': 'Replay',
				'9': 'No One Miking',
				'10': 'No Participants',
				'11': 'Expired',
				'12': 'Deleted',
				'13': 'Cancelled',
				'14': 'Error Status'
			},

			'quarter': {
				'financial-indicators': 'Financial Indicators' //  季度业绩-财务指标
			},

			// 主要财务指标
			'finance-data': {
				'annual': 'Annual',
				'first-quarter': 'First Quarter',
				'interim': 'Interim',
				'third-quarter': 'Third Quarter',
				'fourth-quarter': 'Fourth Quarter'
			},

			// 侧边栏-财务指标
			'slide-finance': {
				'annual': 'Annual',
				'first-quarter': 'First',
				'interim': 'Interim',
				'third-quarter': 'Third',
				'fourth-quarter': 'Fourth'
			},

			// --  数据指标-每股指标
			'bvps': 'BVPS',
			'cfps': 'CFPS',
			'eps': 'EPS',
			'CapSurFdPS': 'CapSurFdPS',
			'ups': 'UPS',
			'operating-income-per-share': 'Operating Income Per Share',

			// --  数据指标-偿还能力指标
			'current-ratio': 'Current Ratio',
			'quick-ratio': 'Quick Ratio',
			'current-debt-ration': 'Current Debt Ration',
			// --  数据指标-营运能力指标
			'accounts-receivable-turnover': 'Accounts Receivable Turnover',
			'inventory-turnover-ratio': 'Inventory Turnover Ratio',
			'current-assets-turnover': 'Current Assets Turnover',
			'FATR': 'FATR',
			'ATR': 'ATR',
			// --  数据指标-盈利能力指标
			'gross-margin': 'Gross Margin',
			'NPM': 'NPM',
			'ROE': 'ROE',
			'ROA': 'ROA',
			'main-indicators': {
				'financial-indicators': 'Financial Indicators' // 主要财务指标-主要指标
			},
			'revenue-growth-rate': 'Revenue Growth Rate',
			'operating-profit-grow-rate': 'Operating Profit Grow Rate',
			'net-profit-growth-rate': 'Net Profit Growth Rate',
			'total-assets-growth-rate': 'Total Assets Growth Rate',
			'CFPS': 'CFPS',

			'YoY': 'YoY',
			'QoQ': 'QoQ',

			// 利润表
			// 利润表 - 数据指标
			'diluted-eps': 'Diluted EPS',
			'total-operating-revenue': 'Operating Revenue',
			'total-operating-cost': 'Total Operating Cost',
			'operating-profit': 'Operating Profit',
			'total-profit': 'Total Profit',
			'net-profit': 'Net Profit',
			'net-profit-of-parent-company-owners': 'CNIS',

			'income-statement': 'Income Statement',

			// 资产负债表
			// 资产负债表 - 数据指标 - 总资产
			'total-assets': 'Total Assets',
			'current-assets': 'Current Assets',
			'non-current-assets': 'Non-Current Assets',
			'money-capital': 'Money Capital',
			'long-term-loans': 'Long-term Loans',
			'owners-equity': "Owner's Equity",
			// 资产负债表 - 数据指标 - 总负债
			'total-liabilitise': 'Total Liabilitise',
			'current-liabilitise': 'Current Liabilitise',
			'non-current-liabilitise': 'Non-Current Liabilitise',
			// 资产负债表 - 数据指标 - 股东权益
			'shareholders-equity': 'Shareholders equity',
			'paid-in-capital': 'Paid-in capital',
			'retained-profit': 'Retained profit',
			'additional-paid-in-Capital': 'Additional Paid-In Capital',
			'legal-reserve': 'Legal Reserve',

			'balance-sheet': 'Balance Sheet',

			// 现金流量表
			// 现金流量表 - 数据指标
			'operating-cash-flow': 'Operating Cash',
			'investing-cash-flow': 'Investing Cash',
			'finaning-cash-flow': 'Finaning Cash',
			'cash-flow': 'Cash Flow',

			// 券商研报
			'research-report-list': 'Research Report List',

			// 'search': 'Search',

			'rating': 'Rating',
			// 券商研报 - 评级
			'BUY': 'BUY',
			'HOLD': 'HOLD',
			'SELL': 'SELL',

			// 公司公告
			'announcement': {
				'all': 'All',
				'title': 'Announcement'
			},
			'announcement-title': 'Title',
			'regular-announcement': 'Regular Announcement',
			'interim-announcement': 'Interim Announcement',

			// 股东结构
			'number-of-shareholders': 'Number of shareholders',
			'thousand-households': 'Thousand households',
			'percentage-of-change': 'Percentage of change',
			'average-holding': 'Average holding',

			'top-10-holders': 'TOP 10 Holders',
			'top-10-float-holders': 'TOP 10 Float Holders',
			'shareholder': 'Shareholder',

			// 北上资金
			'holding-date': 'Date',
			'closing-price': 'Close',
			'daily-change': '%Chg',
			'number-of-shares-held-(shares)': 'Shares Held',
			'number-of-shares-held-shares-unit': 'Shares Held({value})',
			'holding-percentage': 'Ratio Shares',
			'proportion': 'Ratio Shares',
			'northbound-funds': 'Stock Connect',
			'southbound-capital': 'Stock Connect',

			// 融资融卷 - 英文版本做了限制
			'trading-day': '交易日期',
			'current-financing-balance': '本日融资余额(元)',
			'current-financing-purchase-amount': '本日融资买入额(元)',
			'current-short-selling-balance': '本日融券余量(股)',
			'current-short-selling-volume': '本日融券卖出量(股)',
			'short-selling-balance-amount': '融券余量金额(元)',
			'securities-lending-balance': '融资融券余额(元)',

			// 公募持仓
			'fund-name': 'Fund Name',
			'percentage-of-circulating-shares': 'Ratio Share (float)',
			'total-of-holdings': 'Total of Holdings',

			// 预约调研
			'appointment-survey': 'Survey',

			// 互动回答
			'meeting': 'Meeting',
			'enquiry': 'Enquiry',
			'activities': 'Activities',

			'message': 'Message',
			'name': 'Name',
			'tel': 'Tel',
			'email': 'Email',

			// 标准表单
			'normal-field': {
				'name': 'Name',
				'company': 'Company',
				'position': 'Position',
				'phone': 'Phone',
				'email': 'Email',
				'success-email': 'Please enter a valid email',
				'verification': 'Verification',
				'send-code': 'Send code',

				'tips': 'Please enter your {label}',
				'valid-tips': '{label} is a required field',

				'subscribe-success': 'Subscription Successful',

				'enter-phone-number': 'Please enter contact number',
				'invalid-area-code': 'International code does not exist, please reselect',

				'code-sent-to-email': 'Verification code has been sent to email',

				'msg-box': {
					'10015': 'Your contact information already exists, please do not subscribe repeatedly',
					'10016': 'You are already subscribed',
					'10017': 'Your email/contact information already exists, please do not subscribe repeatedly',
					'10018': 'Verification code sent too frequently. Please wait and try again',
					'10019': 'Verification code error',
					'10020': 'Invalid phone number',
					'10021': 'Incorrect email format'
				}
			},
			'subscription-terms': 'Subscription Terms',
			// 投资者留言提示
			'field': {
				'tips': '{label} is a required field',
				'custom-tips': '{label} is a required field',
				'success-email': 'Please enter a valid email',
				'eventName': 'Category',
				'eventName-tips': 'Please select the Category',
				'upload': 'Upload',
				'delete': 'Delete',
				'reupload': 'Re-upload',
				'upload-image-format-error': 'Please upload a valid image format',
				'upload-file-format-error': 'Please upload a valid file format',
				'upload-image-size-limit': 'Image size cannot exceed {limit}MB',
				'upload-file-size-limit': 'File size cannot exceed {limit}MB',
				'upload-file-format-unsupported': 'This file format is not supported'
			},

			// 日历
			'datepicker': {
				'mini-today': 'T',
				'today': 'Today',
				'all-day': 'Day',
				'yesterday': 'Yesterday',
				'tomorrow': 'Tomorrow',
				'year': '', // 展示空
				'day': 'Day',
				'week': 'Week',
				'month': 'Month',
				'type': 'Type',
				'calendar': 'Calendar',
				'announcementType': 'Type'
			},

			// 分析师
			'company': 'Company',
			'analyst': 'Analyst',
			'contact': 'Contact',

			// ESG
			'esg': 'ESG',
			'esg-report': 'ESG Report',

			// 企业管治
			'company-structure': 'Company Structure',
			'structure-report': 'Structure Report',
			'no-structure-data': 'No Data',

			// 时间筛选
			'lastOneYear': '1 year',
			'lastThreeYear': '3 year',
			'lastFiveYear': '5 year',

			'title': 'Title',
			// main_business
			'by-data': 'Data',
			'by-scale': 'Industry',
			'activity': {
				'hour': 'h',
				'minute': 'm',
				'second': 's',
				'day': 'd',
				'startiIn': 'The meeting will start in',
				'addCalendar': 'Add to Calendar',
				'meetingDetails': 'Meeting Details'
			},

			'diagens': {
				'investor-relations': 'Investor Relations',
				'investor-relations-description':
					'Transparent delivery of value,<br/>professional response expectations'
			}
		},
		'下拉刷新': 'Pull down to refresh',
		'释放加载': 'Release to load',
		'刷新完成': 'Refreshed',
		'Title': 'Title',
		'Type': 'Type',
		'Time': 'Time',
		'View': 'View',
		'companyReport': 'Company Report',
		'industryReport': 'Industry Report'
	},
	'zh-cn': {
		'enterprise': {
			'no-data': '暂无数据',
			'no-module-data': '暂无模块',
			'no-menu-data': '暂无配置菜单内容',
			'irstore': '{name}投资者关系',
			'irstore-title': '投资者关系',
			'loading': '加载中...',
			'loading-no-more': '已经到底了',
			'top-post': '置顶',
			'404-error': '抱歉，页面加载失败！',
			'404-back': '返回首页',
			'hontron-irstore-title': '投资者关系首页',

			'submit': '提交',
			'cancel': '取消',
			// 留言成功提示
			'message-sent-success': '提交成功，感谢您的关注和建议！',
			'error': '服务器错误, 请重试',

			'common-a': {
				'updated': '截止时间',
				'until': '截止至'
			},
			'common-b': {
				'updated': '数据更新'
			},

			// 其他
			'more': '更多',
			'see-more': '查看更多',
			'realize-more': '了解更多',
			'view-details': '查看详情',
			'details': '详情',
			'previes': '预览',
			'all': '全部',
			'communication-and-connection': '联系我们',
			'communication-and-connection--RYC': '投资者联络',

			'IR-Contact': '投资者联络',
			'time': '时间',
			'type': '类型',
			'rating-type': '评级',
			'operate': '操作',
			'view': '查看',
			'source': '来源',
			'unchanged': '不变',
			'download': '下载',

			'top': '返回顶部',
			'whistleblower': '投诉举报',
			'message-subscription': '邮件订阅',

			'sie-home': '主页',
			'eyebright-home': '返回官网',
			'home': '首页',
			'indicators': '数据指标',
			'back': '返回',

			'phone': '联系方式',
			'mailbox': '电子邮箱',
			'address': '联系地址',

			// 股票行情
			'chg': '涨跌额',
			'%Chg': '涨跌幅',
			'high': '最高',
			'low': '最低',
			'P/E': '市盈率(TTM)',
			'clear-P/E': '市盈率',
			'P/B': '市净率',
			'turnover': '成交额',
			'volume': '成交量',
			'market-cap': '总市值',
			'market-cap-in-hk09606': '总市值（HKD）',
			'float-cap': '流通值',
			'loss': '亏损',
			'market-quotes': '股票行情',
			'day': '日k',
			'week': '周k',
			'month': '月k',
			'candle': 'K线',
			'candle-picture': 'K线图',
			'UTC': '北京时间',
			'EDT': '美东时间',
			'financial-indicators': '主要指标',

			'ten-thousand': '万',
			'one-hundred-million': '亿',
			'one-trillion': '万亿',
			'rmb': '人民币',

			// 股票行情-K线图
			'k-high': '最高价',
			'k-low': '最低价',
			'k-turnover': '交易额',
			'k-volume': '交易量',
			'k-opening': '开盘价',
			'k-closing': '收盘价',
			'k-chg': '股价变化',
			'quotes-data': '行情数据',

			// 分红配送
			'dividend-announced': '分红年度',
			'announced': '公告日',
			'ex-date': '除尽日',
			'record-date': '登记日',
			'payment-date': '派息日',
			'dividend-scheme': '分红(每10股税前)',
			'recent-dividend-scheme': '最近分红(每10股)',
			'bonus-issue/by-reserve': '送股/转增(每10股)',
			'dividends': '分红送配',
			'disclaimer': '进门财经提供技术支持，仅供交流参考使用，不构成任何投资建议',
			'total-dividend': '总计分红',
			'recent-dividends': '最近分红',
			'frequency': '分红次数',
			'progress': '实施进度',
			'div-yied': '股息率',
			'dividend-ratio': '分红比例',

			// 投关活动
			'default-search': '请输入关键词检索',
			'IR-events': '投关活动',
			'investment': {
				// --------路演状态
				'preview': '预告',
				'live': '直播',
				'playback': '回放',
				'ended': '已结束',
				// --------路演权限
				'audition': '试听',
				'plubic': '公开',
				'pay': '付费',
				'special': '专场',
				'private': '私密',
				'apply': '报名',
				'member': '会员',
				'institution': '机构通',
				'views': '次浏览',
				'summary': '调研纪要',
				'roadshow': '路演活动',
				'research': '调研活动',

				'activity-title': '活动主题'
			},
			'earnings-disclosure': '业绩披露会',
			'shareholders-meeting': '股东大会',

			// 新闻资讯
			'news': '新闻资讯',
			'news-detail': '新闻详情',
			'report-detail': '研报详情',
			'report-title': '研报标题',
			'publish-org': '发布机构',
			'data-time': '新闻时间',
			'news-updated': '最近更新',
			'news-resource': '数据来源',

			// 互动问答
			'QA': {
				'search': '请输入关键字筛选提问或回答内容'
			},
			'question': '互动问答',
			'interactive': '互动易',
			'answer': '答',
			'fold': '收起',
			'from-leave-message': '来源于',
			'answer-to-message': '回答于：',
			'disclose-to-message': '披露于：',

			// 季度业绩
			//--------- 业绩期
			'annual': '年度',
			'interim': '半年度',
			'first-quarter': '一季度',
			'third-quarter': '三季度',
			'fourth-quarter': '四季度',

			//--------- - 内容标题
			'quarter-title': {
				'financial-indicators': '财务数据' // 季度业绩-内容标题-财务数据
			},
			'results-announcement': '业绩公告',
			'results-summary': '业绩摘要',
			'earnings-calls': '业绩路演',
			'earnings-presentation': '业绩演示',
			'business-review-and-outlook': '董事长说',
			'page-version': '一图读懂',
			'earnings-library': '演示材料',
			'roadshow-status': {
				'1': '筹备中',
				'2': '待审批',
				'3': '审批不通过',
				'4': '审批通过',
				'5': '待开始',
				'6': '进行中',
				'7': '已结束',
				'8': '可回放',
				'9': '无人上麦',
				'10': '无人入会',
				'11': '已过期',
				'12': '已删除',
				'13': '已取消',
				'14': '错误状态'
			},

			'quarter': {
				'financial-indicators': '财务指标' //  季度业绩-财务指标
			},

			// 主要财务指标
			'finance-data': {
				'annual': '年报',
				'first-quarter': '一季报',
				'interim': '中报',
				'third-quarter': '三季报',
				'fourth-quarter': '四季报'
			},

			// 侧边栏-财务指标
			'slide-finance': {
				'annual': '年度',
				'interim': '半年度',
				'first-quarter': '一季度',
				'third-quarter': '三季度',
				'fourth-quarter': '四季度'
			},

			// --  数据指标-每股指标
			'bvps': '每股净资产',
			'cfps': '每股现金流',
			'eps': '基本每股收益',
			'CapSurFdPS': '每股公积金',
			'ups': '每股未分配',
			'operating-income-per-share': '每股营收',

			// --  数据指标-偿还能力指标
			'current-ratio': '流动比率',
			'quick-ratio': '速动比率',
			'current-debt-ration': '资产负债比率',
			// --  数据指标-营运能力指标
			'accounts-receivable-turnover': '应收账款周转率',
			'inventory-turnover-ratio': '存货周转率',
			'current-assets-turnover': '流动资产周转率',
			'FATR': '固定资产周转率',
			'ATR': '总资产周转率',
			// --  数据指标-盈利能力指标
			'gross-margin': '毛利率',
			'NPM': '净利润率',
			'ROE': '净资产收益率',
			'ROA': '资产回报率',
			'revenue-growth-rate': '营业收入增长率',
			'operating-profit-grow-rate': '营业利润增长率',
			'net-profit-growth-rate': '净利润增长率',
			'total-assets-growth-rate': '总资产增长率',
			'CFPS': '每股经营现金流',

			'main-indicators': {
				'financial-indicators': '主要财务指标' // 主要财务指标-主要指标
			},

			'YoY': '同比',
			'QoQ': '环比',

			// 利润表
			// 利润表 - 数据指标
			'diluted-eps': '稀释每股收益',
			'total-operating-revenue': '营业收入',
			'total-operating-cost': '营业总成本',
			'operating-profit': '营业利润',
			'total-profit': '利润总额',
			'net-profit': '净利润',
			'net-profit-of-parent-company-owners': '归母净利润',

			'income-statement': '利润表',

			// 资产负债表
			// 资产负债表 - 数据指标 - 总资产
			'total-assets': '总资产',
			'current-assets': '流动资产',
			'non-current-assets': '非流动资产',
			'money-capital': '货币资金',
			'long-term-loans': '长期借款',
			'owners-equity': '所有者权益',
			// 资产负债表 - 数据指标 - 总负债
			'total-liabilitise': '总负债',
			'current-liabilitise': '流动负债',
			'non-current-liabilitise': '非流动负债',
			// 资产负债表 - 数据指标 - 股东权益
			'shareholders-equity': '股东权益',
			'paid-in-capital': '实收资本或股本',
			'retained-profit': '未分配利润',
			'additional-paid-in-Capital': '资本公积',
			'legal-reserve': '盈余公积',

			'balance-sheet': '资产负债表',

			// 现金流量表
			// 现金流量表 - 数据指标
			'operating-cash-flow': '经营现金流净额',
			'investing-cash-flow': '投资现金流净额',
			'finaning-cash-flow': '筹资现金流净额',
			'cash-flow': '现金流量表',

			// 券商研报
			'research-report-list': '研报列表',
			// 'search': 'Search',

			'rating': '券商研报',
			// 券商研报 - 评级
			'BUY': '买入',
			'HOLD': '中性',
			'SELL': '卖出',

			// 公司公告
			'announcement': {
				'all': '全部公告',
				'title': '公司公告'
			},
			'announcement-title': '公告标题',
			'regular-announcement': '定期公告',
			'interim-announcement': '临时公告',

			// 股东结构
			'number-of-shareholders': '股东户数',
			'thousand-households': '万户',
			'percentage-of-change': '较上期变化',
			'average-holding': '户均持股数量',

			'top-10-holders': '十大股东',
			'top-10-float-holders': '十大流通股东',
			'shareholder': '股东',

			// 北上资金
			'holding-date': '持股日期',
			'closing-price': '当日收盘价(元)',
			'daily-change': '当日涨跌幅(%)',
			'number-of-shares-held-(shares)': '持股数量(股)',
			'number-of-shares-held-shares-unit': '持股数量({value}股)',
			'holding-percentage': '持股数量占比(%)',
			'proportion': '占比',
			'northbound-funds': '北上资金',
			'southbound-capital': '南下资金',

			// 融资融卷
			'trading-day': '交易日期',
			'current-financing-balance': '本日融资余额(元)',
			'current-financing-purchase-amount': '本日融资买入额(元)',
			'current-short-selling-balance': '本日融券余量(股)',
			'current-short-selling-volume': '本日融券卖出量(股)',
			'short-selling-balance-amount': '融券余量金额(元)',
			'securities-lending-balance': '融资融券余额(元)',

			// 公募持仓
			'fund-name': '产品名称',
			'percentage-of-circulating-shares': '占流通股比例',
			'total-of-holdings': '总计持股',

			// 预约调研
			'appointment-survey': '扫码预约调研',

			// 互动回答
			'meeting': '会议问答',
			'enquiry': '投资者留言',
			'activities': '投关问答',

			'message': '留言内容',
			'name': '姓名',
			'tel': '手机号',
			'email': '电子邮箱',

			// 标准表单
			'normal-field': {
				'name': '姓名',
				'company': '机构',
				'position': '职位',
				'phone': '联系方式',
				'email': '电子邮箱',
				'success-email': '请填写正确的电子邮箱',
				'verification': '验证码',
				'send-code': '获取验证码',

				'tips': '请填写您的{label}',
				'valid-tips': '请填写您的{label}',

				'subscribe-success': '订阅成功',

				'enter-phone-number': '请输入联系电话',
				'invalid-area-code': '国际代码不存在，请重新选择',

				'code-sent-to-email': '验证码已发送至邮件',

				'msg-box': {
					'10015': '您的联系方式已存在，请勿重复订阅',
					'10016': '邮箱已订阅,请勿重复订阅',
					'10017': '您的电子邮箱/联系方式已存在，请勿重复订阅',
					'10018': '验证码发送过于频繁，请稍候再试',
					'10019': '验证码错误',
					'10020': '非法手机号码',
					'10021': '邮箱格式不正确'
				}
			},
			'subscription-terms': '订阅须知',

			// 投资者留言提示
			'field': {
				'tips': '请填写{label}',
				'custom-tips': '请填写您的{label}',
				'success-email': '请填写正确的电子邮箱',
				'eventName': '订阅事件',
				'eventName-tips': '请选择订阅事件',
				'upload': '上传',
				'delete': '删除',
				'reupload': '重新上传',
				'upload-image-format-error': '请上传正确的图片格式',
				'upload-file-format-error': '请上传正确的文件格式',
				'upload-image-size-limit': '上传图片大小不能超过 {limit}MB',
				'upload-file-size-limit': '上传文件大小不能超过 {limit}MB',
				'upload-file-format-unsupported': '不支持上传该文件格式'
			},
			// 日历
			'datepicker': {
				'mini-today': '今',
				'today': '今天',
				'all-day': '全天',
				'yesterday': '昨天',
				'tomorrow': '明天',
				'year': '年',
				'day': '日',
				'week': '周',
				'month': '月',
				'type': '类型',
				'calendar': '日历',
				'announcementType': '公告类型'
			},

			// 分析师
			'company': '机构',
			'analyst': '分析师',
			'contact': '联系方式',

			// ESG
			'esg': 'ESG评级',
			'esg-report': 'ESG报告',

			// 企业管治
			'company-structure': '企业管治',
			'structure-report': '企业管治文件',
			'no-structure-data': '暂无详细信息',

			// 时间筛选
			'lastOneYear': '近1年',
			'lastThreeYear': '近3年',
			'lastFiveYear': '近5年',

			'title': '标题',
			// main_business
			'by-data': '按数据',
			'by-scale': '按占比',
			'activity': {
				'hour': '时',
				'minute': '分',
				'second': '秒',
				'day': '天',
				'startiIn': '待开始',
				'addCalendar': '加入日历',
				'meetingDetails': '会议详情'
			},

			'diagens': {
				'investor-relations': '投资者关系',
				'investor-relations-description': '透明传递价值，专业回应期待'
			}
		},
		'下拉刷新': '下拉刷新',
		'释放加载': '释放加载',
		'刷新完成': '刷新完成',
		'Title': '标题',
		'Type': '类型',
		'Time': '时间',
		'View': '查看',
		'companyReport': '公司研报',
		'industryReport': '行业研报'
	},
	'zh-hk': {
		'enterprise': {
			'no-data': '暫無數據',
			'no-module-data': '暫無模組',
			'no-menu-data': '暫無配置菜單內容',
			'irstore': '{name}投資者關係',
			'irstore-title': '投資者關係',
			'loading': '加載中...',
			'loading-no-more': '已經到底了',
			'top-post': '置頂',
			'404-error': '抱歉，頁面加載失敗！',
			'404-back': '返回首頁',
			'hontron-irstore-title': '投資者關系首頁',

			'submit': '提交',
			'cancel': '取消',
			// 留言成功提示
			'message-sent-success': '提交成功，感謝您的關注和建議！',
			'error': '服務器錯誤, 請重試',

			'common-a': {
				'updated': '截止時間',
				'until': '截止至'
			},
			'common-b': {
				'updated': '數據更新'
			},

			// 其他
			'more': '更多',
			'see-more': '查看更多',
			'realize-more': '瞭解更多',
			'view-details': '查看詳情',
			'details': '詳情',
			'previes': '預覽',
			'all': '全部',
			'communication-and-connection': '聯繫我們',
			'communication-and-connection--RYC': '投資者聯絡',

			'IR-Contact': '投資者聯絡',
			'time': '時間',
			'type': '類型',
			'rating-type': '評級',
			'operate': '操作',
			'view': '查看',
			'source': '來源',
			'unchanged': '不變',
			'download': '下載',

			'top': '返回頂部',
			'whistleblower': '投訴舉報',
			'message-subscription': '郵件訂閱',

			'sie-home': '主頁',
			'eyebright-home': '返回官網',
			'home': '首頁',
			'indicators': '數據指標',
			'back': '返回',

			'phone': '聯繫方式',
			'mailbox': '電子郵件',
			'address': '聯繫地址',

			// 股票行情
			'chg': '漲跌額',
			'%Chg': '漲跌幅',
			'high': '最高',
			'low': '最低',
			'P/E': '市盈率(TTM)',
			'clear-P/E': '市盈率',
			'P/B': '市淨率',
			'turnover': '成交額',
			'volume': '成交量',
			'market-cap': '總市值',
			'market-cap-in-hk09606': '總市值（HKD）',
			'float-cap': '流通值',
			'loss': '虧損',
			'market-quotes': '股票行情',
			'day': '日k',
			'week': '週k',
			'month': '月k',
			'candle': 'K線',
			'candle-picture': 'K線圖',
			'UTC': '北京時間',
			'EDT': '美东時間',
			'financial-indicators': '主要指標',

			'ten-thousand': '萬',
			'one-hundred-million': '億',
			'one-trillion': '萬億',
			'rmb': '人民幣',

			// 股票行情-K线图
			'k-high': '最高價',
			'k-low': '最低價',
			'k-turnover': '交易額',
			'k-volume': '交易量',
			'k-opening': '開盤價',
			'k-closing': '收盤價',
			'k-chg': '股價變化',
			'quotes-data': '行情數據',

			// 分红配送
			'dividend-announced': '分紅年度',
			'announced': '公告日',
			'ex-date': '除尽日',
			'record-date': '登記日',
			'payment-date': '派息日',
			'dividend-scheme': '分紅(每10股稅前)',
			'recent-dividend-scheme': '最近分紅(每10股)',
			'bonus-issue/by-reserve': '送股/轉增(每10股)',
			'dividends': '分紅送配',
			'disclaimer': '進門財經提供技術支持，僅供交流參考使用，不構成任何投資建議',
			'total-dividend': '總計分紅',
			'recent-dividends': '最近分紅',
			'frequency': '分紅次數',
			'progress': '實施進度',
			'div-yied': '股息率',
			'dividend-ratio': '分紅比例',

			// 投关活动
			'default-search': '請輸入關鍵詞檢索',
			'IR-events': '投關活動',
			'investment': {
				// --------路演状态
				'preview': '預告',
				'live': '直播',
				'playback': '回放',
				'ended': '已結束',
				// --------路演权限
				'audition': '試聽',
				'plubic': '公開',
				'pay': '付費',
				'special': '專場',
				'private': '私密',
				'apply': '報名',
				'member': '會員',
				'institution': '機構通',
				'views': '次瀏覽',
				'summary': '調研紀要',
				'roadshow': '路演活動',
				'research': '調研活動',

				'activity-title': '活動主題'
			},
			'earnings-disclosure': '業績披露會',
			'shareholders-meeting': '股東大會',

			// 新闻资讯
			'news': '新聞資訊',
			'news-detail': '新聞詳情',
			'report-detail': '研報詳情',
			'report-title': '研報標題',
			'publish-org': '發布機構',
			'data-time': '新聞時間',
			'news-updated': '最近更新',
			'news-resource': '數據來源',

			// 互动问答
			'QA': {
				'search': '請輸入關鍵字篩選提問或回答內容'
			},
			'question': '互動問答',
			'interactive': '互動易',
			'answer': '答',
			'fold': '收起',
			'from-leave-message': '來源於',
			'answer-to-message': '回答於：',
			'disclose-to-message': '披露於：',

			// 季度业绩
			//--------- 业绩期
			'annual': '年報',
			'first-quarter': '一季報',
			'interim': '中報',
			'third-quarter': '三季報',
			'fourth-quarter': '四季報',

			//--------- - 内容标题
			'quarter-title': {
				'financial-indicators': '財務數據' // 季度业绩-内容标题-财务数据
			},
			'results-announcement': '業績公告',
			'results-summary': '業績摘要',
			'earnings-calls': '業績路演',
			'earnings-presentation': '業績演示',
			'business-review-and-outlook': '董事長說',
			'page-version': '一圖讀懂',
			'earnings-library': '演示材料',
			'roadshow-status': {
				'1': '籌備中',
				'2': '待審批',
				'3': '審批不通過',
				'4': '審批通過',
				'5': '待開始',
				'6': '進行中',
				'7': '已結束',
				'8': '可回放',
				'9': '無人上麥',
				'10': '無人入會',
				'11': '已過期',
				'12': '已刪除',
				'13': '已取消',
				'14': '錯誤狀態'
			},

			'quarter': {
				'financial-indicators': '財務指標' //  季度业绩-财务指标
			},

			// 主要财务指标
			'finance-data': {
				'annual': '年報',
				'first-quarter': '一季報',
				'interim': '中報',
				'third-quarter': '三季報',
				'fourth-quarter': '四季報'
			},

			// 侧边栏-财务指标
			'slide-finance': {
				'annual': '年度',
				'interim': '半年度',
				'first-quarter': '一季度',
				'third-quarter': '三季度',
				'fourth-quarter': '四季度'
			},

			// --  数据指标-每股指标
			'bvps': '每股淨資產',
			'cfps': '每股現金流',
			'eps': '基本每股收益',
			'CapSurFdPS': '每股公積金',
			'ups': '每股未分配',
			'operating-income-per-share': '每股營收',

			// --  数据指标-偿还能力指标
			'current-ratio': '流動比率',
			'quick-ratio': '速動比率',
			'current-debt-ration': '資產負債比率',
			// --  数据指标-营运能力指标
			'accounts-receivable-turnover': '應收賬款周轉率',
			'inventory-turnover-ratio': '存貨周轉率',
			'current-assets-turnover': '流動資產周轉率',
			'FATR': '固定資產周轉率',
			'ATR': '總資產周轉率',
			// --  数据指标-盈利能力指标
			'gross-margin': '毛利率',
			'NPM': '淨利潤率',
			'ROE': '淨資產收益率',
			'ROA': '資產回報率',
			'revenue-growth-rate': '營業收入增長率',
			'operating-profit-grow-rate': '營業利潤增長率',
			'net-profit-growth-rate': '凈利潤增長率',
			'total-assets-growth-rate': '總資產增長率',
			'CFPS': '每股經營現金流',

			'main-indicators': {
				'financial-indicators': '主要財務指標' // 主要财务指标-主要指标
			},

			'YoY': '同比',
			'QoQ': '環比',

			// 利润表
			// 利润表 - 数据指标
			'diluted-eps': '稀釋每股收益',
			'total-operating-revenue': '營業收入',
			'total-operating-cost': '營業總成本',
			'operating-profit': '營業利潤',
			'total-profit': '利潤總額',
			'net-profit': '淨利潤',
			'net-profit-of-parent-company-owners': '歸母淨利潤',

			'income-statement': '利潤表',

			// 资产负债表
			// 资产负债表 - 数据指标 - 总资产
			'total-assets': '總資產',
			'current-assets': '流動資產',
			'non-current-assets': '非流動資產',
			'money-capital': '貨幣資金',
			'long-term-loans': '長期借款',
			'owners-equity': '所有者權益',
			// 资产负债表 - 数据指标 - 总负债
			'total-liabilitise': '總負債',
			'current-liabilitise': '流動負債',
			'non-current-liabilitise': '非流動負債',
			// 资产负债表 - 数据指标 - 股东权益
			'shareholders-equity': '股東權益',
			'paid-in-capital': '實收資本或股本',
			'retained-profit': '未分配利潤',
			'additional-paid-in-Capital': '資本公積',
			'legal-reserve': '盈餘公積',

			'balance-sheet': '資產負債表',

			// 现金流量表
			// 现金流量表 - 数据指标
			'operating-cash-flow': '經營現金流淨額',
			'investing-cash-flow': '投資現金流淨額',
			'finaning-cash-flow': '籌資現金流淨額',
			'cash-flow': '現金流量表',

			// 券商研报
			'research-report-list': '研報列表',
			// 'search': 'Search',

			'rating': '券商研報',
			// 券商研报 - 评级
			'BUY': '買入',
			'HOLD': '中性',
			'SELL': '賣出',

			// 公司公告
			'announcement': {
				'all': '全部公告',
				'title': '公司公告'
			},
			'announcement-title': '公告標題',
			'regular-announcement': '定期公告',
			'interim-announcement': '臨時公告',

			// 股东结构
			'number-of-shareholders': '股東戶數',
			'thousand-households': '萬戶',
			'percentage-of-change': '較上期變化',
			'average-holding': '戶均持股數量',

			'top-10-holders': '十大股東',
			'top-10-float-holders': '十大流通股東',
			'shareholder': '股東',

			// 北上资金
			'holding-date': '持股日期',
			'closing-price': '當日收盤價(元)',
			'daily-change': '當日漲跌幅 (%)',
			'number-of-shares-held-(shares)': '持股數量(股)',
			'number-of-shares-held-shares-unit': '持股數量({value}股)',
			'holding-percentage': '持股數量占比(%)',
			'proportion': '佔比',
			'northbound-funds': '北上資金',
			'southbound-capital': '南下資金',

			// 融资融卷
			'trading-day': '交易日期',
			'current-financing-balance': '本日融資餘額(元)',
			'current-financing-purchase-amount': '本日融資買入額(元)',
			'current-short-selling-balance': '本日融券餘量(股)',
			'current-short-selling-volume': '本日融券賣出量(股)',
			'short-selling-balance-amount': '融券餘量金額(元)',
			'securities-lending-balance': '融資融券餘額(元)',

			// 公募持仓
			'fund-name': '產品名稱',
			'percentage-of-circulating-shares': '佔流通股比例',
			'total-of-holdings': '總計持股',

			// 预约调研
			'appointment-survey': '掃碼預約調研',

			// 互动回答
			'meeting': '會議問答',
			'enquiry': '投資者留言',
			'activities': '投關問答',

			'message': '留言内容',
			'name': '姓名',
			'tel': '手機號',
			'email': '電子郵箱',

			// 标准表单
			'normal-field': {
				'name': '姓名',
				'company': '機構',
				'position': '職位',
				'phone': '聯繫方式',
				'email': '電子郵箱',
				'success-email': '請填寫正確的電子郵件',
				'verification': '驗證碼',
				'send-code': '獲取驗證碼',

				'tips': '請填寫您的{label}',
				'valid-tips': '請填寫您的{label}',

				'subscribe-success': '訂閱成功',

				'enter-phone-number': '請輸入聯繫電話',
				'invalid-area-code': '國際代碼不存在，請重新選擇',

				'code-sent-to-email': '驗證碼已發送至郵件',

				'msg-box': {
					'10015': '您的聯繫方式已存在，請勿重複訂閱',
					'10016': '郵箱已訂閱,請勿重複訂閱',
					'10017': '您的電子郵箱/聯繫方式已存在，請勿重複訂閱',
					'10018': '驗証碼髮送過於頻繁，請稍候再試',
					'10019': '驗證碼錯誤',
					'10020': '非法手機號碼',
					'10021': '郵箱格式不正確'
				}
			},
			'subscription-terms': '訂閱須知',
			// 投资者留言提示
			'field': {
				'tips': '請填寫{label}',
				'custom-tips': '請填寫您的{label}',
				'success-email': '請填寫正確的電子郵件',
				'eventName': '訂閱事件',
				'eventName-tips': '請選擇訂閱事件',
				'upload': '上傳',
				'delete': '刪除',
				'reupload': '重新上傳',
				'upload-image-format-error': '請上傳正確的圖片格式',
				'upload-file-format-error': '請上傳正確的文件格式',
				'upload-image-size-limit': '上傳圖片大小不能超過 {limit}MB',
				'upload-file-size-limit': '上傳文件大小不能超過 {limit}MB',
				'upload-file-format-unsupported': '不支持上傳該文件格式'
			},
			// 日历
			'datepicker': {
				'mini-today': '今',
				'today': '今天',
				'all-day': '全天',
				'yesterday': '昨天',
				'tomorrow': '明天',
				'year': '年',
				'day': '日',
				'week': '週',
				'month': '月',
				'type': '類型',
				'calendar': '日曆',
				'announcementType': '公告類型'
			},

			// 分析师
			'company': '機構',
			'analyst': '分析師',
			'contact': '聯繫方式',

			// ESG
			'esg': 'ESG評級',
			'esg-report': 'ESG報告',

			// 企业管治
			'company-structure': '企業管治',
			'structure-report': '企業管治文件',
			'no-structure-data': '暫無詳細信息',

			// 时间筛选
			'lastOneYear': '近1年',
			'lastThreeYear': '近3年',
			'lastFiveYear': '近5年',

			'title': '標題',
			// main_business
			'by-data': '按數據',
			'by-scale': '按占比',
			'activity': {
				'hour': '時',
				'minute': '分',
				'second': '秒',
				'day': '天',
				'startiIn': '待開始',
				'addCalendar': '添加日曆',
				'meetingDetails': '會議詳情'
			},

			'diagens': {
				'investor-relations': '投資者關係',
				'investor-relations-description': '透明傳遞價值，專業回應期待'
			}
		},
		'下拉刷新': '下拉刷新',
		'释放加载': '释放加载',
		'刷新完成': '刷新完成',
		'Title': '標題',
		'Type': '類型',
		'Time': '時間',
		'View': '查看',
		'companyReport': '公司研報',
		'industryReport': '行業研報'
	}
};
